import ikonic from "./ikonic";

export default {
  "ikonic tower": ikonic
};
